import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "../interseptor/axiosConf";
import ToastrNotifi from "../Utilities/ToastrNotifi";

const fetchTags = () => {
    const beURL = localStorage.getItem('BeURL');  // Localized inside the function
    return axios.get(`${beURL}tags/-1`).then(res => res.data);
};

export const useTagsData = (enabled) => {
    return useQuery({
        queryKey: ['tagsData'],
        queryFn: fetchTags,
        enabled,  // Conditionally enable the query
        staleTime: 5 * 60 * 1000,
    });
};

//newly added 
// Custom hook for adding a new tag
export const useAddTag = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (newTag) => {
            const { data } = await axios.post('/api/create/tag', newTag);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['tagsData']);  // Refresh tags data
            ToastrNotifi.successToast("New Tag Added");
        },
    });
};
